// extracted by mini-css-extract-plugin
module.exports = {"numbers":"numbers-module--numbers--2gvUJ","statistic":"numbers-module--statistic--17Icg"};